"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getTooltipOverflowContainerMaxHeight = function getTooltipOverflowContainerMaxHeight(_ref) {
  var theme = _ref.theme;
  return "".concat(parseInt(theme.maxHeight, 10) - parseInt(theme.padding, 10) * 2, "px");
};

var TooltipContent = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  max-height: ", ";\n  overflow-x: auto;\n"])), getTooltipOverflowContainerMaxHeight);

var _default = TooltipContent;
exports["default"] = _default;